function validateSome() {
  return {
    restrict: "A",
    require: "ngModel",
    scope: {
      validateSome: "=",
    },
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$validators.validateSome = (modelValue, viewValue) => {
        // Consider empty models to be valid
        if ($ctrl.$isEmpty(modelValue)) return true;

        return !$scope.validateSome.some((val) => val === viewValue);
      };
    },
  };
}

export default validateSome;
